<template>
  <div>
    <b-modal
      v-model="modalShow"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center my-3">
        <img
          class="session-expiry-img"
          width="20%"
          src="@/assets/img/session-expired.png"
          alt=""
        />
        <h4 class="mt-4">
          <b> {{ title }}</b>
        </h4>
        <p>{{ description }}</p>
        <p>{{ $t("expiry-modals.contactStore") }}</p>
        <!-- <button class="expiry-close-btn mt-3" @click="close">Close</button> -->
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    show: Boolean,
    title: String,
    description: String,
  },
  data() {
    return {
      modalShow: false,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.modalShow = val;
      },
    },
  },
  methods: {
    close() {
      this.$emit(`closeIframe`);
    },
  },
};
</script>
<style scoped>
.expiry-close-btn {
  padding: 10px 50px;
  background: none;
  border: 2px solid #5559fe;
}
</style>
